<template>
  <base-modal :id="modalId" :ok-handler="okHandler" :title="title">
    <div>
      <p>Please enter the organization information below. Be sure to verify all information is correct before submitting. You will not be able to change this information.</p>
      <form ref="editOrgForm" class="sa-form" @submit.prevent="onSubmit">
        <div class="form-row">
          <div class="form-group col-md-4">
            <label for="name">Organization name<span class="label-required">*</span></label>
            <input
              id="name"
              v-model="name"
              class="form-control"
              type="text"
              placeholder="Name"
              required="true"
            />
          </div>
          <div class="form-group col-md-4">
            <label for="contact">Contact name<span class="label-required">*</span></label>
            <input
              id="contact"
              v-model="contact"
              class="form-control"
              type="text"
              placeholder="Contact name"
              required="true"
            />
          </div>
          <div class="form-group col-md-4">
            <label for="phoneNum">Phone number<span class="label-required">*</span></label>
            <input
              id="phoneNum"
              v-model="phoneNum"
              class="form-control"
              type="tel"
              maxlength="12"
              pattern="([0-9]{3}-[0-9]{3}-[0-9]{4})|[0-9]{10}"
              title="Please match the following 10-digit format: 555-555-5555"
              placeholder="___-___-____"
              required="true"
            />
          </div>
        </div>
      </form>
      <small class="form-row">
        <span class="label-required">*</span> required field
      </small>
    </div>
  </base-modal>
</template>

<script>
import BaseModal from './BaseModal';
import reportValidity from 'report-validity';

export default {
  name: 'EditOrgModal',
  components: { BaseModal },
  props: {
    title: {
      type: String,
      default: '',
    }
  },
  data() {
    return {
      name: '',
      contact: '',
      phoneNum: '',
      modalId: 'edit-org-modal',
    }
  },
  mounted() {
    this.resetData();
    const handleClose = this.handleClose;
    this.$root.$on('bv::modal::hide', handleClose);
  },
  methods: {
    resetData: function() {
      this.name = '';
      this.contact = '';
      this.phoneNum = '';
    },
    handleClose: function(bvModalEvt) {
      if (bvModalEvt.componentId === this.modalId) {
        this.$store.dispatch('clearDuplicateState');
        this.resetData();
      }
    },
    isValid: function(values) {
      console.log('isValid: ', values);
      return true;
    },
    handleSubmit: function(e) {
      if (e) e.preventDefault();
      const values = {
        name: this.name,
        contact: this.contact,
        phone: `+1${this.phoneNum.replace(/[^0-9]/g,'')}`,
      };

      if (this.isValid(values)) {
        // TODO: Some API Action Here
        // TODO: Depending on the status of the action, close the modal, or pass the closer as a callback
        const payload = {
          vm: this,
          org: values,
        };
        this.$store.dispatch('createOrg', payload);
        this.closeModal();
      }
    },
    okHandler: function(bvModalEvt) {
      bvModalEvt.preventDefault();
      if (this.$refs.editOrgForm) {
        //if (this.$refs.editOrgForm.reportValidity()) {
        let isValidForm = reportValidity(this.$refs.editOrgForm);
        if (isValidForm) {
          this.handleSubmit();
        }
      }
    },
    closeModal: async function() {
      await this.$nextTick();
      this.resetData();
      this.$store.dispatch('clearOrgState');
      this.$bvModal.hide(this.modalId);
    }
  },
}
</script>
